import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { PlayerMatchResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A single ranked match (GET /ranking/matches/{matchId}) — the payload behind the
 * report-result surface. Returned VERBATIM (players[] in server order, mode,
 * status, winner_side, reported_by); the page owns side-mapping + name
 * resolution but never re-derives status. Disabled until a matchId resolves so a
 * not-yet-resolved route param never fires a request for `undefined`.
 *
 * Mirrors `useRating`: a thin React-Query wrapper, cached under the
 * `compete.match` key namespace.
 */
export function useMatch(matchId: string | undefined) {
  return useQuery<PlayerMatchResponse>({
    queryKey: queryKeys.compete.match(matchId ?? ""),
    queryFn: () => rankingApi.getMatch(matchId as string),
    enabled: Boolean(matchId),
  });
}
